import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AddToOrderViewModel } from '@order/models/add-to-order-view-model';
import { DisplayType } from '@shared/constants/order-status-title.enum';
import { Order, OrderHeader, OrderStatus } from '@usf/ngrx-order';

@Component({
  selector: 'app-add-to-order-products',
  templateUrl: './add-to-order-products.component.html',
  styleUrls: ['./add-to-order-products.component.scss'],
})
export class AddToOrderProductsComponent {
  @Input() vm: AddToOrderViewModel;
  @Input() index: any;
  @Output() selectionEmitter = new EventEmitter<AddToOrderViewModel>();
  DisplayType = DisplayType;
  OrderStatus = OrderStatus;
  isOrderSelected = null;

  constructor() {}

  onOrderSelection(selectedRadioItem: AddToOrderViewModel) {
    this.isOrderSelected === selectedRadioItem
      ? (this.isOrderSelected = null)
      : (this.isOrderSelected = selectedRadioItem);

    this.selectionEmitter.emit(selectedRadioItem);
  }

  isValidDate(dateToValidate: any): boolean {
    try {
      if (new Date(dateToValidate).toString() === 'Invalid Date') return false;
    } catch (e) {
      return false;
    }
    return true;
  }

  calculateTotalPrice = (orderHeader: OrderHeader) => {
    return (
      (orderHeader.totalDollars || 0) +
        (orderHeader.totalSalesTax || 0) +
        (orderHeader.totalCharges || 0) -
        Math.abs(orderHeader.totalAllowances || 0) || 0
    );
  };
}
